<app-header></app-header>
<vryf-flex-messages></vryf-flex-messages>
<div class="main-content d-flex flex-column flex-1 min-h-0 overflow-hidden">
    <router-outlet></router-outlet>
</div>